<div class="file-drop-area">
  <span class="choose-file-btn">{{ buttonText }}</span>
  <span class="file-msg">{{file ? file.name : dragDropText }}</span>
  <input class="file-input" type="file" [accept]="accept">
</div>
